"use client";

import Link from "next/link";
import React from "react";
import './breadcrumbs.scss';
import { getBlogHomePath } from 'helpers/url';
import { useTranslations } from 'next-intl';

export interface Breadcrumb {
  name: string;
  slug: string;
}

export interface BreadcrumbsProps {
  site: string;
  breadcrumbs?: Breadcrumb[];
  current?: string | null;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  site,
  breadcrumbs = [],
  current = null,
}) => {
  const blogHomePath = getBlogHomePath({ site });
  const t = useTranslations('Breadcrumbs');

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb">
      <span className="prev">
        <Link href={blogHomePath}>{t('home')}</Link>
      </span>

      {breadcrumbs.map((breadcrumb, index) => (
        <span key={`breadcrumb-${index}`} className="prev">
          <Link href={breadcrumb.slug}>{breadcrumb.name}</Link>
        </span>
      ))}

      {current && (
        <span className="current" aria-current="page">
          {current}
        </span>
      )}
    </nav>
  );
};

export default Breadcrumbs;